import Link from 'components/Globals/Base/Link';
import Rank from 'components/Ranking/Rank';
import getWellRankingListItemTestId from 'constants/testsIds/wellRankingListItem';
import { ensureUrlTrailingSlash } from 'utils/stringUtils';
import * as S from './NextPreviousNavStyles';

interface NextPreviousNavProps {
  color: string;
  showRank: boolean;
  next: string;
  previous: string;
  rank: string;
}

const NextPreviousNav = ({ color, showRank, next, previous, rank }: NextPreviousNavProps) => (
  <S.Wrapper>
    {showRank && (
      <Rank
        className='rank'
        color={color}
        rank={rank}
      />
    )}
    <S.LinksWrapper>
      {previous ? (
        <Link
          className='previous-link'
          type='tertiaryBlackButton'
          href={ensureUrlTrailingSlash(previous)}
          dataCy={getWellRankingListItemTestId('PREVIOUS')}
          hasLeftArrow
          hasRightArrow={false}
        >
          Previous
        </Link>
      ) : null}
      {next ? (
        <Link
          className='next-link'
          type='tertiaryBlackButton'
          href={ensureUrlTrailingSlash(next)}
          dataCy={getWellRankingListItemTestId('NEXT')}
          hasRightArrow
        >
          Next
        </Link>
      ) : null}
    </S.LinksWrapper>
  </S.Wrapper>
);

export default NextPreviousNav;
